import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function FeaturedListings() {
    const [searchFilter, setSearchFilter] = useState({ zip: '', service: '' });
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFeaturedListings = async () => {
            const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3005';

            try {
                const res = await fetch(`${backendUrl}/api/listings`);
                if (res.ok) {
                    const data = await res.json();
                    const fetchedListings = Array.isArray(data) ? data : (data?.listings || data?.data || []);
                    setListings(fetchedListings.slice(0, 4));
                }
            } catch (err) {
                console.error('Failed to fetch featured listings', err);
            } finally {
                setLoading(false);
            }
        };

        fetchFeaturedListings();
    }, []);

    const filteredLocksmiths = listings.filter((pro) => {
        const matchesService = searchFilter.service ? (pro.service || pro.services?.join(', ')) === searchFilter.service : true;
        return matchesService;
    });
    return (
        <>

            {/* Featured Listings */}
            <section id="featured" className="py-xl px-gutter max-w-container-max w-full mx-auto scroll-mt-20">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-lg gap-4">
                    <div>
                        <h2 className="font-headline-md text-headline-md text-primary mb-2">Featured Professionals</h2>
                        <p className="font-body-md text-body-md text-on-surface-variant">Top-rated locksmiths in your area with verified credentials.</p>
                    </div>
                    <a href="#featured" className="text-primary font-button flex items-center hover:underline decoration-2 font-bold whitespace-nowrap">
                        View All Experts <span className="material-symbols-outlined ml-1">arrow_forward</span>
                    </a>
                </div>

                {loading ? (
                    <div className="text-center py-xl text-on-surface-variant">Loading featured listings...</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-sm">
                        {filteredLocksmiths.map((pro) => {
                            const normalizedPro = {
                                id: pro.id ?? pro._id ?? pro.slug,
                                name: pro.name ?? pro.businessName ?? pro.companyName ?? pro.title ?? 'Professional Locksmith',
                                rating: Number(pro.rating ?? pro.averageRating ?? 0),
                                reviews: pro.reviews ?? 0,
                                tags: Array.isArray(pro.tags) ? pro.tags : (Array.isArray(pro.categories) ? pro.categories : []),
                                coverImage: pro.coverImage?.url,
                                isPremium: Boolean(pro.isPremium ?? pro.premium ?? false),
                                isVerified: Boolean(pro.isVerified ?? pro.verified ?? true),
                                phone: pro.phone ?? pro.contactNumber ?? '',
                                service: pro.service ?? (Array.isArray(pro.services) ? pro.services.join(', ') : 'General Service'),
                                description: pro.description ?? ''
                            };

                            return (
                                <div
                                    key={normalizedPro.id}
                                    className="bg-white rounded-xl border border-outline-variant hover:shadow-lg transition-all duration-300 group overflow-hidden flex flex-col hover:-translate-y-1"
                                >
                                    <div className="h-48 relative overflow-hidden">
                                        <img
                                            alt={normalizedPro.name}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                            src={normalizedPro.coverImage}
                                        />
                                        {normalizedPro.isVerified && (
                                            <div className="absolute top-4 left-4 bg-primary text-on-primary px-3 py-1 rounded-full text-[12px] font-bold flex items-center gap-1 shadow-sm">
                                                <span className="material-symbols-outlined text-[14px]" style={{ fontVariationSettings: "'FILL' 1" }}>
                                                    verified
                                                </span>
                                                VERIFIED
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-6 flex flex-1 flex-col justify-between">
                                        <div>
                                            <div className="flex justify-between items-start mb-2">
                                                <Link
                                                    to={`/profile/${normalizedPro.id}`}
                                                    className="font-headline-md text-[20px] text-primary group-hover:text-secondary-container transition-colors"
                                                >
                                                    {normalizedPro.name}
                                                </Link>
                                                {normalizedPro.rating > 0 && (
                                                    <div className="flex items-center text-secondary-container shrink-0">
                                                        <span className="material-symbols-outlined text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>
                                                            star
                                                        </span>
                                                        <span className="font-bold ml-1 text-on-surface">{normalizedPro.rating.toFixed(1)}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <p className="text-on-surface-variant text-body-md mb-4 line-clamp-2">
                                                {normalizedPro.description}
                                            </p>
                                            {normalizedPro.tags.length > 0 && (
                                                <div className="flex flex-wrap gap-2 mb-6">
                                                    {normalizedPro.tags.slice(0, 3).map((tag, idx) => (
                                                        <span
                                                            key={idx}
                                                            className={`px-3 py-1 rounded-full text-[12px] font-bold ${tag.includes('Emergency') || tag.includes('Response')
                                                                ? 'bg-secondary-fixed text-on-secondary-fixed-variant'
                                                                : 'bg-surface-container text-primary'
                                                                }`}
                                                        >
                                                            {tag}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="border-t border-outline-variant pt-4 flex items-center justify-between">

                                            <Link
                                                to={`/profile/${normalizedPro.id}`}
                                                className="bg-primary text-on-primary px-6 py-2.5 rounded-lg font-label-md hover:bg-primary-container transition-all active:scale-[0.97]"
                                            >
                                                View Profile
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {!loading && filteredLocksmiths.length === 0 && (
                    <div className="text-center py-xl border border-dashed border-outline-variant/30 rounded-3xl mt-lg">
                        <span className="material-symbols-outlined text-outline text-[48px] mb-4">search_off</span>
                        <p className="text-body-lg text-on-surface-variant">No locksmiths found matching this service.</p>
                        <button
                            onClick={() => setSearchFilter({ zip: '', service: '' })}
                            className="mt-4 text-primary font-bold hover:underline"
                        >
                            Clear Filters
                        </button>
                    </div>
                )}
            </section>
        </>
    )
}

export default FeaturedListings